<template>
  <div>
    <Dialog
      header="Header"
      v-model:visible="showDeleteDialog"
      style="min-width: 65%"
    >
      <template #header>
        <strong>Conferma</strong>
      </template>
      Confermi di voler segnare le notifiche come lette?
      <template #footer>
        <Button
          @click="segnaNotificheVisibiliLetteOK"
          icon="pi pi-trash"
          label="Conferma"
          class="p-button-danger"
        />
        <Button
          @click="showDeleteDialog = false"
          icon="pi pi-times"
          label="Annulla"
        />
      </template>
    </Dialog>
    <!-- <div class="nav-bar-responsive"> -->
    <div
      v-if="
        isAuth &&
        $route.name != 'mini-sito' &&
        $route.name != 'mini-sito-dettaglio' &&
        $route.name != 'mini-sitol' &&
        $route.name != 'mini-sito-dettagliol' &&
        $route.name != 'form-contatti-empty' &&
        $route.name != 'form-contatti-lingua' &&
        $route.name != 'form-contatti-flag' &&
        $route.name != 'form-contatti-emptyl' &&
        $route.name != 'form-contatti-lingual' &&
        $route.name != 'form-contatti-flagl' &&
        $route.name != 'unsub-newsletters' &&
        $route.path != '/login'
      "
    >
      <div class="nav-custom-bar">
        <div class="nav-custom">
          <div class="nav-custom--container">
            <div class="nav-custom--container--center">
              <div
                class="nav-custom--link"
                style="
                  cursor: pointer;
                  position: absolute;
                  margin-top: 38px;
                  margin-left: -103px;
                "
              >
                <div
                  class=""
                  v-show="
                    this.$route.name == 'home' ||
                    this.$route.name == 'dashboard'
                  "
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link :to="homeLink" class="nav-custom--link--text">
                    <img
                      class="cloudvillage-logo"
                      alt="Vue logo"
                      style="width: 40px"
                      src="@/assets/imgs/cloud-village-hd-logo.png"
                    />
                  </router-link>
                </div>
              </div>
              <div class="nav-custom--link">
                <div
                  class="nav-custom--link--active"
                  v-show="
                    this.$route.name == 'home' ||
                    this.$route.name == 'dashboard'
                  "
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    :to="homeLink"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'home' ||
                      this.$route.name == 'dashboard'
                        ? 'color: #f6c363;'
                        : ''
                    "
                  >
                    <span v-show="!auth" class="button-text">Home</span>
                    <span v-show="auth" class="button-text">Dashboard</span>
                  </router-link>
                </div>
              </div>
              <div
                class="nav-custom--link"
                style="cursor: pointer"
                @mouseover="item2_show = true"
                @mouseleave="item2_show = false"
              >
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'preventivi'"
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    :to="{ name: 'preventivi' }"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'preventivi' ? 'color: #f6c363;' : ''
                    "
                  >
                    <li
                      class="glowing-dot"
                      v-if="
                        notifications &&
                        notifications.notif &&
                        notifications.notif.length > 0 &&
                        notifications.notif.find(
                          (not) => not.group === 'accettazione'
                        )
                      "
                    ></li>
                    <span
                      class="button-text"
                      :style="
                        notifications &&
                        notifications.notif &&
                        notifications.notif.length > 0 &&
                        notifications.notif.find(
                          (not) => not.group === 'accettazione'
                        )
                          ? 'margin-left: -10px'
                          : ''
                      "
                      >Preventivi</span
                    >
                  </router-link>
                  <Menu
                    :model="items2"
                    style="
                      position: absolute;
                      margin-top: 16px;
                      margin-left: 16px;
                    "
                    v-if="item2_show"
                  />
                </div>
              </div>
              <div
                class="nav-custom--link"
                style="cursor: pointer"
                @mouseover="item3_show = true"
                @mouseleave="item3_show = false"
              >
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'clienti'"
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    to="/clienti"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'clienti' ? 'color: #f6c363;' : ''
                    "
                  >
                    <span class="button-text">Contatti</span>
                  </router-link>
                  <Menu
                    :model="items3"
                    style="
                      position: absolute;
                      margin-top: 16px;
                      margin-left: 16px;
                    "
                    v-if="item3_show"
                  />
                </div>
              </div>
              <div class="nav-custom--link" style="cursor: pointer">
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'mail'"
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    :to="{ name: 'mail' }"
                    class="nav-custom--link--text"
                    :style="this.$route.name == 'mail' ? 'color: #f6c363;' : ''"
                  >
                    <li class="glowing-dot" v-show="n_notifiche > 0"></li>

                    <span class="button-text">Mail</span>
                    <!-- <Badge
                      style="margin-left: 10px"
                      v-if="n_notifiche > 0"
                      >{{ n_notifiche }}</Badge
                    > -->
                  </router-link>
                </div>
              </div>
              <div
                class="nav-custom--link"
                style="cursor: pointer"
                @mouseover="item4_show = true"
                @mouseleave="item4_show = false"
              >
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'mailing-list'"
                ></div>
                <div class="nav-custom--link--text"
                v-if="this.camping && this.camping.MailjetAPI && this.camping.MailjetAPI != '' &&  this.camping.MailjetSecret && this.camping.MailjetSecret != ''">
                  <!--! link  -->
                  <router-link
                    :to="{ name: 'mailing-list' }"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'mailing-list'
                        ? 'color: #f6c363;'
                        : ''
                    "
                  >
                    <span class="button-text">Newsletters</span>
                  </router-link>
                  <Menu
                    :model="items4"
                    style="
                      position: absolute;
                      margin-top: 16px;
                      margin-left: 16px;
                    "
                    v-if="item4_show"
                  />
                </div>
              </div>
              <div
                class="nav-custom--link"
                style="cursor: pointer"
                @mouseover="item5_show = true"
                @mouseleave="item5_show = false"
              >
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'richieste'"
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    :to="{ name: 'richieste' }"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'richieste' ? 'color: #f6c363;' : ''
                    "
                  >
                    <li
                      class="glowing-dot"
                      v-if="
                        notifications &&
                        notifications.notif &&
                        notifications.notif.length > 0 &&
                        notifications.notif.find(
                          (not) => not.group === 'richiesta'
                        )
                      "
                    ></li>
                    <span
                      class="button-text"
                      :style="
                        notifications &&
                        notifications.notif &&
                        notifications.notif.length > 0 &&
                        notifications.notif.find(
                          (not) => not.group === 'richiesta'
                        )
                          ? 'margin-left: -10px'
                          : ''
                      "
                      >Richieste</span
                    >
                  </router-link>
                </div>
              </div>
              <!--! Nome del campeggio -->
              <div
                class="nav-custom--link"
                style="user-select: none; cursor: default"
              >
                <div class="nav-custom--link--text nav-custom--link-campeggio">
                  <span class="nome-campeggio"> {{ NomeCapeggio }} </span>
                </div>
              </div>
            </div>

            <div
              class="nav-custom--container--right"
              style="cursor: pointer"
              @click="openNotificationPanel()"
            >
              <div class="nav-custom--link">
                <div
                  class="nav-custom--link--text"
                  style="
                    position: absolute;
                    margin-top: -4px;
                    margin-left: -35px;
                    width: 60px;
                  "
                >
                  <!--! link  -->
                  <i
                    class="pi pi-bell"
                    style="font-size: 1.2rem; text-align: center"
                    @click="showNotificationPanel"
                    v-badge.warning
                    v-if="
                      notifications &&
                      notifications.notif &&
                      notifications.notif.length === 1
                    "
                  />
                  <i
                    class="pi pi-bell"
                    style="font-size: 1.2rem; text-align: center"
                    @click="showNotificationPanel"
                    v-badge.warning="notifications.count"
                    v-else-if="
                      notifications &&
                      notifications.notif &&
                      notifications.notif.length > 1
                    "
                  />
                  <i
                    class="pi pi-bell"
                    style="font-size: 1.2rem; text-align: center"
                    v-else
                  />
                </div>
              </div>
              <div class="nav-custom--link">
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'settings' || this.$route.name == 'settingsl'"
                ></div>
                <div
                  class="nav-custom--link--text"
                  @mouseover="item6_show = true"
                  @mouseleave="item6_show = false"
                >
                  <!--! link  -->
                  <router-link
                    :to="lucee ? { name: 'settingsl' } : { name: 'settings' }"
                    class="nav-custom--link--text"
                    :style="
                      (this.$route.name == 'settings' || this.$route.name == 'settingsl') ? 'color: #f6c363;' : ''
                    "
                  >
                    <span class="button-text"
                      ><i class="pi pi-bars" style="font-size: 2.1rem"
                    /></span>
                  </router-link>
                  <Menu
                    :model="items6"
                    style="
                      position: absolute;
                      margin-top: 7px;
                      margin-left: -130px;
                      width: 210px;
                    "
                    v-if="item6_show"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="nav-custom-bar nav-custom-bar-mobile-landscape">
        <div class="nav-custom">
          <div class="nav-custom--container">
            <div class="nav-custom--container--center">
              <div
                class="nav-custom--link"
                style="
                  cursor: pointer;
                  position: absolute;
                  margin-top: 38px;
                  margin-left: -48px;
                "
              >
                <div
                  class=""
                  v-show="
                    this.$route.name == 'home' ||
                    this.$route.name == 'dashboard'
                  "
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link :to="homeLink" class="nav-custom--link--text">
                    <img
                      class="cloudvillage-logo"
                      alt="Vue logo"
                      style="width: 40px"
                      src="@/assets/imgs/cloud-village-hd-logo.png"
                    />
                  </router-link>
                </div>
              </div>
              <div class="nav-custom--link" style="margin-left: 20px;">
                <div
                  class="nav-custom--link--active"
                  v-show="
                    this.$route.name == 'home' ||
                    this.$route.name == 'dashboard'
                  "
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    :to="homeLink"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'home' ||
                      this.$route.name == 'dashboard'
                        ? 'color: #f6c363;'
                        : ''
                    "
                  >
                    <span v-show="!auth" class="button-text">Home</span>
                    <span v-show="auth" class="button-text"
                      ><i class="fa-solid fa-chart-line"></i
                    ></span>
                  </router-link>
                </div>
              </div>
              <div
                class="nav-custom--link"
                style="cursor: pointer"
                @mouseover="item2_show = true"
                @mouseleave="item2_show = false"
              >
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'preventivi'"
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    :to="{ name: 'preventivi' }"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'preventivi' ? 'color: #f6c363;' : ''
                    "
                  >
                    <li
                      class="glowing-dot"
                      v-if="
                        notifications &&
                        notifications.notif &&
                        notifications.notif.length > 0 &&
                        notifications.notif.find(
                          (not) => not.group === 'accettazione'
                        )
                      "
                    ></li>
                    <span
                      class="button-text"
                      :style="
                        notifications &&
                        notifications.notif &&
                        notifications.notif.length > 0 &&
                        notifications.notif.find(
                          (not) => not.group === 'accettazione'
                        )
                          ? 'margin-left: -10px'
                          : ''
                      "
                      ><i class="fa-solid fa-file-invoice"></i
                    ></span>
                  </router-link>
                  <Menu
                    :model="items2"
                    style="
                      position: absolute;
                      margin-top: 16px;
                      margin-left: 16px;
                    "
                    v-if="item2_show"
                  />
                </div>
              </div>
              <div
                class="nav-custom--link"
                style="cursor: pointer"
                @mouseover="item3_show = true"
                @mouseleave="item3_show = false"
              >
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'clienti'"
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    to="/clienti"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'clienti' ? 'color: #f6c363;' : ''
                    "
                  >
                    <span class="button-text"
                      ><i class="fa-solid fa-user"></i
                    ></span>
                  </router-link>
                  <Menu
                    :model="items3"
                    style="
                      position: absolute;
                      margin-top: 16px;
                      margin-left: 16px;
                    "
                    v-if="item3_show"
                  />
                </div>
              </div>
              <div class="nav-custom--link" style="cursor: pointer">
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'mail'"
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    :to="{ name: 'mail' }"
                    class="nav-custom--link--text"
                    :style="this.$route.name == 'mail' ? 'color: #f6c363;' : ''"
                  >
                    <span class="button-text"
                      ><i class="fa-solid fa-envelope"></i
                    ></span>
                  </router-link>
                </div>
              </div>
              <div
                class="nav-custom--link"
                style="cursor: pointer"
                @mouseover="item4_show = true"
                @mouseleave="item4_show = false"
              >
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'mailing-list'"
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    :to="{ name: 'mailing-list' }"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'mailing-list'
                        ? 'color: #f6c363;'
                        : ''
                    "
                  >
                    <span class="button-text"
                      ><i class="fa-solid fa-paper-plane"></i
                    ></span>
                  </router-link>
                  <Menu
                    :model="items4"
                    style="
                      position: absolute;
                      margin-top: 16px;
                      margin-left: 16px;
                    "
                    v-if="item4_show"
                  />
                </div>
              </div>
              <div
                class="nav-custom--link"
                style="cursor: pointer"
                @mouseover="item5_show = true"
                @mouseleave="item5_show = false"
              >
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'richieste'"
                ></div>
                <div class="nav-custom--link--text">
                  <!--! link  -->
                  <router-link
                    :to="{ name: 'richieste' }"
                    class="nav-custom--link--text"
                    :style="
                      this.$route.name == 'richieste' ? 'color: #f6c363;' : ''
                    "
                  >
                    <li
                      class="glowing-dot"
                      v-if="
                        notifications &&
                        notifications.notif &&
                        notifications.notif.length > 0 &&
                        notifications.notif.find(
                          (not) => not.group === 'richiesta'
                        )
                      "
                    ></li>
                    <span
                      class="button-text"
                      :style="
                        notifications &&
                        notifications.notif &&
                        notifications.notif.length > 0 &&
                        notifications.notif.find(
                          (not) => not.group === 'richiesta'
                        )
                          ? 'margin-left: -10px'
                          : ''
                      "
                      ><i class="fa-solid fa-question"></i
                    ></span>
                  </router-link>
                </div>
              </div>
              <!--! Nome del campeggio -->
              <div
                class="nav-custom--link"
                style="
                  user-select: none;
                  cursor: default;
                  right: 170px;
                  position: absolute;
                  top: 57px;
                "
              >
                <div class="nav-custom--link--text nav-custom--link-campeggio">
                  <span class="nome-campeggio"> {{ NomeCapeggio }} </span>
                </div>
              </div>
            </div>

            <div
              class="nav-custom--container--right"
              style="cursor: pointer"
              @click="openNotificationPanel()"
            >
              <div class="nav-custom--link">
                <div
                  class="nav-custom--link--text"
                  style="
                    position: absolute;
                    margin-top: -4px;
                    margin-left: -55px;
                    width: 60px;
                  "
                >
                  <!--! link  -->
                  <i
                    class="pi pi-bell"
                    style="font-size: 1.2rem; text-align: center"
                    @click="showNotificationPanel"
                    v-badge.warning
                    v-if="notifications && notifications.count === 1"
                  />
                  <i
                    class="pi pi-bell"
                    style="font-size: 1.2rem; text-align: center"
                    @click="showNotificationPanel"
                    v-badge.warning="notifications.count"
                    v-else-if="notifications && notifications.count > 1"
                  />
                  <i
                    class="pi pi-bell"
                    style="font-size: 1.2rem; text-align: center"
                    v-else
                  />
                </div>
              </div>
              <div class="nav-custom--link">
                <div
                  class="nav-custom--link--active"
                  v-show="this.$route.name == 'settings' || this.$route.name == 'settingsl'"
                ></div>
                <div
                  class="nav-custom--link--text"
                  @mouseover="item6_show = true"
                  @mouseleave="item6_show = false"
                >
                  <!--! link  -->
                  <router-link
                    :to="lucee ? { name: 'settingsl' } : { name: 'settings' }"
                    class="nav-custom--link--text"
                    :style="
                      (this.$route.name == 'settings' || this.$route.name == 'settingsl') ? 'color: #f6c363;' : ''
                    "
                  >
                    <span class="button-text"
                      ><i class="pi pi-bars" style="font-size: 2.1rem"
                    /></span>
                  </router-link>
                  <Menu
                    :model="items6"
                    style="
                      position: absolute;
                      margin-top: 7px;
                      margin-left: -130px;
                      width: 210px;
                    "
                    v-if="item6_show"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <nav
        class="navbar navbar-expand-lg navbar-light bg-light nav-custom-bar-mobile-portrait"
      >
        <div
          class="nav-custom-bar navbar navbar-expand-lg navbar-light bg-light nav-custom-bar-mobile-portrait"
        >
          <div class="nav-custom">
            <div class="nav-custom--container">
              <div class="nav-custom--container--center">
                <div
                  class="nav-custom--link"
                  style="
                    cursor: pointer;
                    position: absolute;
                    margin-top: 38px;
                    margin-left: -30px;
                  "
                >
                  <div
                    class=""
                    v-show="
                      this.$route.name == 'home' ||
                      this.$route.name == 'dashboard'
                    "
                  ></div>
                  <div class="nav-custom--link--text">
                    <!--! link  -->
                    <router-link :to="homeLink" class="nav-custom--link--text">
                      <img
                        class="cloudvillage-logo"
                        alt="Vue logo"
                        style="width: 40px"
                        src="@/assets/imgs/cloud-village-hd-logo.png"
                      />
                    </router-link>
                  </div>
                </div>
                <!--! Nome del campeggio -->
                <div
                  class="nav-custom--link"
                  style="user-select: none; cursor: default; width: 100%"
                >
                  <div
                    class="nav-custom--link--text nav-custom--link-campeggio"
                  >
                    <span class="nome-campeggio"> {{ NomeCapeggio }} </span>
                  </div>
                </div>

                <button
                  class="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  @click="toggleMobileMenu()"
                >
                  <span class="navbar-toggler-icon"></span>
                </button>

                <div
                  class="menu-mobile-scorrevole"
                  :class="
                    showMenuScorrevole
                      ? 'menu-animation-display'
                      : 'menu-animation-hide'
                  "
                >
                  <div class="nav-custom--link nav-custom--link-mobile">
                    <div
                      class="nav-custom--link--active"
                      v-show="
                        this.$route.name == 'home' ||
                        this.$route.name == 'dashboard'
                      "
                    ></div>
                    <div
                      class="nav-custom--link--text nav-custom--link--text-mobile"
                    >
                      <!--! link  -->
                      <router-link
                        :to="homeLink"
                        class="nav-custom--link--text nav-custom--link--text-mobile"
                        :style="
                          this.$route.name == 'home' ||
                          this.$route.name == 'dashboard'
                            ? 'color: #f6c363;'
                            : ''
                        "
                        @click="toggleMobileMenu()"
                      >
                        <span v-show="!auth" class="button-text">Home</span>
                        <span v-show="auth" class="button-text">Dashboard</span>
                      </router-link>
                    </div>
                  </div>
                  <div
                    class="nav-custom--link nav-custom--link-mobile"
                    style="cursor: pointer"
                    @mouseover="item2_show = true"
                    @mouseleave="item2_show = false"
                  >
                    <div
                      class="nav-custom--link--active"
                      v-show="this.$route.name == 'preventivi'"
                    ></div>
                    <div
                      class="nav-custom--link--text nav-custom--link--text-mobile"
                    >
                      <!--! link  -->
                      <router-link
                        :to="{ name: 'preventivi' }"
                        class="nav-custom--link--text nav-custom--link--text-mobile"
                        :style="
                          this.$route.name == 'preventivi'
                            ? 'color: #f6c363;'
                            : ''
                        "
                        @click="toggleMobileMenu()"
                      >
                        <li
                          class="glowing-dot"
                          v-if="
                            notifications &&
                            notifications.notif &&
                            notifications.notif.length > 0 &&
                            notifications.notif.find(
                              (not) => not.group === 'accettazione'
                            )
                          "
                        ></li>
                        <span
                          class="button-text"
                          :style="
                            notifications &&
                            notifications.notif &&
                            notifications.notif.length > 0 &&
                            notifications.notif.find(
                              (not) => not.group === 'accettazione'
                            )
                              ? 'margin-left: -10px'
                              : ''
                          "
                          >Preventivi</span
                        >
                      </router-link>
                    </div>
                  </div>
                  <div
                    class="nav-custom--link nav-custom--link-mobile"
                    style="cursor: pointer"
                    @mouseover="item3_show = true"
                    @mouseleave="item3_show = false"
                  >
                    <div
                      class="nav-custom--link--active"
                      v-show="this.$route.name == 'clienti'"
                    ></div>
                    <div
                      class="nav-custom--link--text nav-custom--link--text-mobile"
                    >
                      <!--! link  -->
                      <router-link
                        to="/clienti"
                        class="nav-custom--link--text nav-custom--link--text-mobile"
                        :style="
                          this.$route.name == 'clienti' ? 'color: #f6c363;' : ''
                        "
                        @click="toggleMobileMenu()"
                      >
                        <span class="button-text">Contatti</span>
                      </router-link>
                    </div>
                  </div>
                  <div
                    class="nav-custom--link nav-custom--link-mobile"
                    style="cursor: pointer"
                  >
                    <div
                      class="nav-custom--link--active"
                      v-show="this.$route.name == 'mail'"
                    ></div>
                    <div
                      class="nav-custom--link--text nav-custom--link--text-mobile"
                    >
                      <!--! link  -->
                      <router-link
                        :to="{ name: 'mail' }"
                        class="nav-custom--link--text nav-custom--link--text-mobile"
                        :style="
                          this.$route.name == 'mail' ? 'color: #f6c363;' : ''
                        "
                        @click="toggleMobileMenu()"
                      >
                        <span class="button-text">Mail</span>
                      </router-link>
                    </div>
                  </div>
                  <div
                    class="nav-custom--link nav-custom--link-mobile"
                    style="cursor: pointer"
                    @mouseover="item4_show = true"
                    @mouseleave="item4_show = false"
                  >
                    <div
                      class="nav-custom--link--active"
                      v-show="this.$route.name == 'mailing-list'"
                    ></div>
                    <div
                      class="nav-custom--link--text nav-custom--link--text-mobile"
                    >
                      <!--! link  -->
                      <router-link
                        :to="{ name: 'mailing-list' }"
                        class="nav-custom--link--text nav-custom--link--text-mobile"
                        :style="
                          this.$route.name == 'mailing-list'
                            ? 'color: #f6c363;'
                            : ''
                        "
                        @click="toggleMobileMenu()"
                      >
                        <span class="button-text">Newsletters</span>
                      </router-link>
                    </div>
                  </div>
                  <div
                    class="nav-custom--link nav-custom--link-mobile"
                    style="cursor: pointer"
                    @mouseover="item5_show = true"
                    @mouseleave="item5_show = false"
                  >
                    <div
                      class="nav-custom--link--active"
                      v-show="this.$route.name == 'richieste'"
                    ></div>
                    <div
                      class="nav-custom--link--text nav-custom--link--text-mobile"
                    >
                      <!--! link  -->
                      <router-link
                        :to="{ name: 'richieste' }"
                        class="nav-custom--link--text nav-custom--link--text-mobile"
                        :style="
                          this.$route.name == 'richieste'
                            ? 'color: #f6c363;'
                            : ''
                        "
                        @click="toggleMobileMenu()"
                      >
                        <li
                          class="glowing-dot"
                          v-if="
                            notifications &&
                            notifications.notif &&
                            notifications.notif.length > 0 &&
                            notifications.notif.find(
                              (not) => not.group === 'richiesta'
                            )
                          "
                        ></li>
                        <span
                          class="button-text"
                          :style="
                            notifications &&
                            notifications.notif &&
                            notifications.notif.length > 0 &&
                            notifications.notif.find(
                              (not) => not.group === 'richiesta'
                            )
                              ? 'margin-left: -10px'
                              : ''
                          "
                          >Richieste</span
                        >
                      </router-link>
                    </div>
                  </div>

                  <div
                    class="nav-custom--link nav-custom--link-mobile"
                    style="cursor: pointer"
                    @mouseover="item5_show = true"
                    @mouseleave="item5_show = false"
                  >
                    <div
                      class="nav-custom--link--active"
                      v-show="this.$route.name == 'richieste'"
                    ></div>
                    <div
                      class="nav-custom--link--text nav-custom--link--text-mobile"
                    >
                      <!--! link  -->
                      <router-link
                        :to="lucee ? { name: 'settingsl' } : { name: 'settings' }"
                        class="nav-custom--link--text nav-custom--link--text-mobile"
                        :style="
                          (this.$route.name == 'settings' || this.$route.name == 'settingsl')
                            ? 'color: #f6c363;'
                            : ''
                        "
                        @click="toggleMobileMenu()"
                      >
                        <span class="button-text"
                          ><span class="button-text">Impostazioni</span></span
                        >
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <!--! Pannello delle notifiche -->

      <div class="">
        <OverlayPanel
          ref="op"
          appendTo="body"
          :showCloseIcon="false"
          id="overlay_panel"
          style="width: 400px"
          :breakpoints="{ '960px': '75vw' }"
        >
          <div
            class="p-datatable p-component p-datatable-hoverable-rows p-datatable-responsive-scroll p-datatable-gridlines"
            data-scrollselectors=".p-datatable-wrapper"
            pv_id_4=""
          >
            <div class="p-datatable-wrapper">
              <button
                type="button"
                class="btn btn-outline-secondary"
                style="width: 362px; height: 26px; padding: 0"
                @click="
                  notificationsIndex -= 5;
                  checkNotifications();
                "
                v-if="notificationsIndex > 0"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-double-up"
                  viewBox="0 0 16 16"
                  style="margin-top: -2px"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.646 2.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 3.707 2.354 9.354a.5.5 0 1 1-.708-.708z"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M7.646 6.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 7.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
                  />
                </svg>
              </button>
              <table
                role="table"
                class="p-datatable-table"
                style="width: 362px; min-width: 362px"
              >
                <tbody class="p-datatable-tbody" role="rowgroup">
                  <tr
                    class="p-selectable-row red_bg"
                    tabindex="0"
                    role="row"
                    draggable="false"
                    style="height: 45px"
                    v-for="notification in notifications.notif"
                    :key="notification"
                  >
                    <td
                      class=""
                      role="cell"
                      style="
                        text-align: center;
                        width: 15%;
                        padding: 5px !important;
                        border: 0;
                      "
                      @click="
                        this.$router.push(linkToNotif(notification));
                        markAsRead(notification._id);
                        showNotificationPanel();
                      "
                    >
                      <span class="image-text">
                        <img
                          :src="
                            require('@/assets/imgs/notifications/' +
                              notification.group +
                              '.png')
                          "
                          style="width: 32px; background-color: aliceblue"
                        />
                      </span>
                    </td>
                    <td
                      class=""
                      role="cell"
                      style="
                        text-align: center;
                        width: 50%;
                        padding: 5px !important;
                        border: 0;
                      "
                      @click="
                        this.$router.push(linkToNotif(notification));
                        markAsRead(notification._id);
                        showNotificationPanel();
                      "
                    >
                      <span class="image-text">{{ notification.title }}</span>
                      <br />
                      <span
                        class="image-text"
                        style="
                          display: block;
                          font-size: smaller;
                          margin-top: -4px;
                          font-style: italic;
                        "
                        >{{ notification.desc }}</span
                      >
                    </td>
                    <td
                      class=""
                      role="cell"
                      style="
                        text-align: center;
                        width: 20%;
                        padding: 5px !important;
                        border: 0;
                      "
                      @click="
                        this.$router.push(linkToNotif(notification));
                        markAsRead(notification._id);
                        showNotificationPanel();
                      "
                    >
                      <span
                        class="image-text"
                        style="
                          font-size: 14px;
                          font-style: italic;
                          font-weight: 100;
                        "
                        >{{ fancyDateHour(notification.date) }}</span
                      >
                      <br />
                      <span
                        class="image-text"
                        style="
                          display: block;
                          font-size: smaller;
                          margin-top: -4px;
                          font-style: italic;
                        "
                        >{{
                          new Date(notification.date)
                            .getHours()
                            .toString()
                            .padStart(2, "0") +
                          ":" +
                          new Date(notification.date)
                            .getMinutes()
                            .toString()
                            .padStart(2, "0") +
                          ":" +
                          new Date(notification.date)
                            .getSeconds()
                            .toString()
                            .padStart(2, "0")
                        }}</span
                      >
                    </td>
                    <td
                      class=""
                      role="cell"
                      style="
                        width: 368px;
                        height: inherit;
                        position: absolute;
                        left: 0;
                        background-color: #00000094;
                        z-index: 1;
                        text-align: center;
                        padding-top: calc(112px - 2rem);
                        color: white;
                      "
                      v-if="bottoneSegnaNotificheVisibiliLette"
                    >
                      <i
                        class="pi pi-spin pi-spinner"
                        style="font-size: 2rem; margin: auto"
                      ></i>
                    </td>
                  </tr>
                </tbody>
                <!--
                <tr class="p-selectable-row red_bg" tabindex="0" role="row" draggable="false" style="height: 45px; background: transparent; cursor: auto;">
                  <button type="button" class="btn btn-primary" :disabled="bottoneSegnaNotificheVisibiliLette" style="margin-top: 8px; position: absolute; right: calc(50% - 110px); left: calc(50% - 110px); width: 220px;" @click="segnaNotificheVisibiliLette()">Segna come lette</button>
                </tr>
                <tr class="p-selectable-row red_bg" tabindex="0" role="row" draggable="false" style="height: 45px; background: transparent; cursor: auto;">
                  <button type="button" class="btn btn-secondary" :disabled="bottoneSegnaNotificheVisibiliLette" style="margin-top: 8px; position: absolute; right: calc(50% - 110px); left: calc(50% - 110px); width: 220px;" @click="segnaNotificheTutteLette()">Segna tutte come lette</button>
                </tr>
                -->
              </table>
              <button
                type="button"
                class="btn btn-outline-secondary"
                style="width: 362px; height: 26px; padding: 0"
                @click="
                  notificationsIndex += 5;
                  checkNotifications();
                "
                v-if="
                  notifications.count > 5 &&
                  notificationsIndex + 5 < notifications.count
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-double-down"
                  viewBox="0 0 16 16"
                  style="margin-top: -2px"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                  <path
                    fill-rule="evenodd"
                    d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                :disabled="bottoneSegnaNotificheVisibiliLette"
                style="width: 362px; margin-top: 10px"
                @click="segnaNotificheVisibiliLette()"
              >
                Segna come lette
              </button>
            </div>
          </div>
        </OverlayPanel>
      </div>
    </div>
    <div v-else>
      <div class="nav-custom-bar2">
        <div class="nav-custom">
          <div class="nav-custom--container"></div>
        </div>
      </div>
    </div>
    <!-- </div>
    <div>
      <Sidebar v-model:visible="visibleLeft"> Content </Sidebar>
    </div> -->
  </div>
</template>

<script>
import { ref, onBeforeMount, watch, computed } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import fancyDate from "../../assets/js/date/fancyDate.js";
import fancyDateHour from "../../assets/js/date/fancyDateHour.js";
import { useToast } from "primevue/usetoast";
import { io } from "socket.io-client";
export default {
  inject: ["links"],
  props: {
    authenticated: Boolean,
  },
  beforeCreate() {
    this.started = false;
  },
  beforeMount() {
    this.started = true;
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const auth = ref(false);

    const showMenuScorrevole = ref(false);
    const token = ref(store.getters["auth/getToken"]);
    const items = ref(
      Array.from({ length: 10 }, (_, i) => ({
        label: `Notifica #${i + 1}`,
        value: i,
      }))
    );
    const selectedItem = ref(null);
    watch(route, () => {
      token.value = store.getters["auth/getToken"];
      if (token.value) {
        auth.value = true;
      } else {
        auth.value = false;
      }
    });
    onBeforeMount(() => {
      if (token.value) {
        auth.value = true;
      }
    });

    function toggleMobileMenu() {
      showMenuScorrevole.value = !showMenuScorrevole.value;
      document.body.style.overflow = showMenuScorrevole.value ? "hidden" : "";
    }
    const mouseOverSetting = ref(false);

    const toast = useToast();
    const router = useRouter();

    const items1 = ref([
      {
        label: "Options",
        items: [
          {
            label: "Update",
            icon: "pi pi-refresh",
            command: () => {
              toast.add({
                severity: "success",
                summary: "Updated",
                detail: "Data Updated",
                life: 3000,
              });
            },
          },
          {
            label: "Delete",
            icon: "pi pi-times",
            command: () => {
              toast.add({
                severity: "warn",
                summary: "Delete",
                detail: "Data Deleted",
                life: 3000,
              });
            },
          },
        ],
      },
      {
        label: "Navigate",
        items: [
          {
            label: "Vue Website",
            icon: "pi pi-external-link",
            url: "https://vuejs.org/",
          },
          {
            label: "Router",
            icon: "pi pi-upload",
            command: () => {
              window.location.hash = "/fileupload";
            },
          },
        ],
      },
    ]);

    const items2 = ref([
      {
        label: "Preventivi",
        items: [
          {
            label: "Nuovo Preventivo",
            icon: "pi pi-plus",
            command: () => {
              if (route.name != "richiedi-preventivo") {
                router.push({ name: "richiedi-preventivo" });
              } else {
                toast.add({
                  severity: "warn",
                  summary: "Attenzione!",
                  detail: 'Sei già sulla pagina "Crea Preventivo"!',
                  life: 3000,
                });
              }
            },
          },
        ],
      },
    ]);
    const items3 = ref([
      {
        label: "Contatti",
        items: [
          {
            label: "Nuovo Cliente",
            icon: "pi pi-user",
            command: () => {
              router.push({
                name: "clienti",
                params: { newClient: "newClient" },
              });
            },
          },
        ],
      },
    ]);
    const items4 = ref([
      {
        label: "Newsletters",
        items: [
          {
            label: "Template",
            icon: "pi pi-list",
            command: () => {
              router.push({ name: "template-dashboard" });
            },
          },
          {
            label: "Procedura guidata",
            icon: "pi pi-external-link",
            command: () => {
              router.push({ name: "steps-list-dash" });
            },
          },
        ],
      },
    ]);
    const items5 = ref([
      {
        label: "Options",
        items: [
          {
            label: "Update",
            icon: "pi pi-refresh",
            command: () => {
              toast.add({
                severity: "success",
                summary: "Updated",
                detail: "Data Updated",
                life: 3000,
              });
            },
          },
          {
            label: "Delete",
            icon: "pi pi-times",
            command: () => {
              toast.add({
                severity: "warn",
                summary: "Delete",
                detail: "Data Deleted",
                life: 3000,
              });
            },
          },
        ],
      },
      {
        label: "Navigate",
        items: [
          {
            label: "Vue Website",
            icon: "pi pi-external-link",
            url: "https://vuejs.org/",
          },
          {
            label: "Router",
            icon: "pi pi-upload",
            command: () => {
              window.location.hash = "/fileupload";
            },
          },
        ],
      },
    ]);
    async function logoutUser() {
      await store.dispatch("auth/logout");
      router.push("/login");
      auth.value = false;
    }
    const lucee = computed(() => {
      try {
        const raw = store.getters["auth/getUser"];
        if (!raw) return false;
        const user = typeof raw === "string" ? JSON.parse(raw) : raw;
        const camps = store.getters["auth/getCampings"] || [];
        const camp = camps.find(el => el._id == user?.camping);
        return !!camp?.lucee;
      } catch {
        return false;
      }
    });

    const items6 = ref([
      {
        label: "Impostazioni CRM",
        items: [
          {
            label: "Aggiungi utente",
            icon: "pi pi-user-plus",
            command: () => {
              router.push(lucee.value ? "/settingsL?v=detUser" : "/settings?v=detUser");
            },
          },
          {
            label: "Visualizza Utenti",
            icon: "pi pi-users",
            command: () => {
              router.push(lucee.value ? "/settingsL?v=showUsers" : "/settings?v=showUsers");
            },
          },
          {
            label: "Opzioni Preventivo",
            icon: "pi pi-briefcase",
            command: () => {
              router.push(lucee.value ? "/settingsL?v=settPrev" : "/settings?v=settPrev");
            },
          },
          {
            label: "Aggiungi Campeggio",
            icon: "pi pi-plus-circle",
            command: () => {
              router.push(lucee.value ? "/settingsL?v=addCamp" : "/settings?v=addCamp");
            },
          },
          {
            label: "Visualizza Campeggi",
            icon: "pi pi-search",
            command: () => {
              router.push(lucee.value ? "/settingsL?v=showCamp" : "/settings?v=showCamp");
            },
          },
        ],
      },
      {
        label: "Impostazioni Utente",
        items: [
          {
            label: "Account CRM",
            icon: "pi pi-user",
            command: () => {
              router.push(lucee ? "/settingsL?v=detUser" : "/settings?v=detUser");
            },
          },
          {
            label: "Account Gmail",
            icon: "pi pi-envelope",
            command: () => {
              router.push(lucee ? "/settingsL?v=gmail" : "/settings?v=gmail");
            },
          },
          {
            label: auth.value ? "Login" : "Logout",
            icon: auth.value ? "pi pi-check" : "pi pi-times",
            command: () => {
              auth.value ? logoutUser() : router.push("/login");
            },
          },
        ],
      },
    ]);

    const mobileItems = ref([
      {
        label: "Dashboard",
        icon: "pi pi-fw pi-file",
      },
      {
        label: "Preventivi",
        icon: "pi pi-fw pi-pencil",
        items: [
          {
            label: "Nuovo Preventivo",
            icon: "pi pi-fw pi-align-left",
          },
        ],
      },
      {
        label: "Contatti",
        icon: "pi pi-fw pi-user",
        items: [
          {
            label: "Nuovo Cliente",
            icon: "pi pi-fw pi-user-plus",
          },
        ],
      },
      {
        label: "Mail",
        icon: "pi pi-fw pi-calendar",
      },
      {
        label: "Newsletters",
        icon: "pi pi-fw pi-user",
        items: [
          {
            label: "Template",
            icon: "pi pi-fw pi-user-plus",
          },
          {
            label: "Procedura Guidata",
            icon: "pi pi-fw pi-user-plus",
          },
        ],
      },
      {
        label: "Richieste",
        icon: "pi pi-fw pi-calendar",
      },
      {
        label: "Impostazioni",
        icon: "pi pi-fw pi-pencil",
        items: [
          {
            label: "",
            icon: "pi pi-fw pi-align-left",
          },
        ],
      },
    ]);

    return {
      token,
      auth,
      mouseOverSetting,
      items,
      items1,
      items2,
      items3,
      items4,
      items5,
      items6,
      selectedItem,
      mobileItems,
      showMenuScorrevole,
      toggleMobileMenu,
    };
  },
  data() {
    return {
      started: false,
      navbarOpen: true,
      icons: true,
      user: {},
      item1_show: false,
      item2_show: false,
      item3_show: false,
      item4_show: false,
      item5_show: false,
      item6_show: false,
      notifications: [],
      tabTitle: "",
      notificationsIndex: 0,
      isAuth: false,
      camping: false,
      lucee: false,
      notificationTimer: undefined,
      n_notifiche: 0,
      bottoneSegnaNotificheVisibiliLette: false,
      showDeleteDialog: false,
      socket: null,
    };
  },
  async created() {
    await this.checkAuth();
    await this.$store.dispatch("auth/getCampings");
    var tmp_usr = this.$store.getters["auth/getUser"];
    if (tmp_usr) {
      this.user = JSON.parse(tmp_usr);
      while (!(this.user instanceof Object)) {
        this.user = JSON.parse(tmp_usr);
      }
    }
    this.camping = this.$store.getters["auth/getCampings"].find(
      (el) => el._id == this.user.camping
    );
    this.lucee = this.camping?.lucee

    if (!this.user.isAdmin) {
      this.items6 = [
        {
          label: "Impostazioni CRM",
          items: [
            {
              label: "Opzioni Preventivo",
              icon: "pi pi-briefcase",
              command: () => {
                this.$router.push(this.lucee ? "/settingsL?v=settPrev" : "/settings?v=settPrev");
              },
            },
          ],
        },
        {
          label: "Impostazioni Utente",
          items: [
            {
              label: "Account CRM",
              icon: "pi pi-user",
              command: () => {
                this.$router.push(this.lucee ? "/settingsL?v=detUser" : "/settings?v=detUser");
              },
            },
            {
              label: "Account Gmail",
              icon: "pi pi-envelope",
              command: () => {
                this.$router.push(this.lucee ? "/settingsL?v=gmail" : "/settings?v=gmail");
              },
            },
            {
              label: !this.isAuth ? "Login" : "Logout",
              icon: !this.isAuth ? "pi pi-check" : "pi pi-times",
              command: () => {
                this.isAuth
                  ? this.logoutThisUser()
                  : this.$router.push("/login");
              },
            },
          ],
        },
      ];
    }

    await this.getEmailsUnread();
  },
  async beforeRouteUpdate() {
    await this.checkAuth();
    await this.checkNotifications();
  },
  async beforeRouteEnter() {
    await this.checkAuth();
  },
  async beforeRouteLeave() {
    await this.checkAuth();
  },

  methods: {
    async logoutThisUser() {
      await this.$store.dispatch("auth/logout");
      this.$router.push("/login");
      this.auth = false;
    },
    async checkAuth() {
      if (!this.isAuth) {
        this.isAuth = this.$store.getters["auth/getToken"] ? true : false;
      }
    },
    focusNavbar() {
      this.navbarOpen = !this.navbarOpen;
    },
    async checkNotifications() {
      if (this.tabTitle === "") {
        this.tabTitle = document.title;
      }
      if (document.title != this.tabTitle) {
        document.title = "(❗) " + this.tabTitle;
      }
      if (this.isAuth) {
        if (
          this.$route.name &&
          this.$route.name != "form-contatti-empty" &&
          this.$route.name != "form-contatti-lingua" &&
          this.$route.name != "form-contatti-flag" &&
          this.$route.name != "form-contatti-emptyl" &&
          this.$route.name != "form-contatti-lingual" &&
          this.$route.name != "form-contatti-flagl"
        ) {
          var user = JSON.parse(await this.$store.getters["auth/getUser"]);
          if (user.packLevel > 0) {
            this.notifications = await this.$store.dispatch(
              "notifications/getNotifications",
              { index: this.notificationsIndex }
            );
            // console.log(this.notifications);
            if (this.notifications.count > 0) {
              document.title =
                "(" + this.notifications.count + ") " + this.tabTitle;
            } else {
              document.title = this.tabTitle;
            }
          } else {
            document.title = this.tabTitle;
          }
        } else {
          document.title = this.tabTitle;
        }
      } else {
        document.title = this.tabTitle;
      }
    },
    blurNavbar() {
      setTimeout(() => {
        this.navbarOpen = !this.navbarOpen;
        this.$refs["tgl"].click();
      }, 400);
    },
    async logout() {
      await this.$store.dispatch("auth/logout");
      window.location.href = "/login";

      this.auth = false;
    },
    login() {
      this.$router.push("/login");
    },
    showNotificationPanel(e) {
      this.$refs.op.toggle(e);
      setTimeout(() => {
        document.getElementById('overlay_panel').style.position = 'fixed'
        document.getElementById('overlay_panel').style.display = 'block'
        document.getElementById('overlay_panel').style.top = '47px'
      }, 5);
    },
    fancyDateHour,
    //! link per visualizzare la notifica collegata
    linkToNotif(source) {
      var link = {
        name: "",
        params: {},
        query: {},
      };

      //! Preventivi
      if (source.group === "preventivo" || source.group === "accettazione") {
        link.name = "preventivo-prew";
        link.params.idPreventivo = source.link.idPreventivo;
        link.params.idCliente = source.link.idCliente;
      }
      //! richiesta preventivo
      if (source.group === "richiesta") {
        link.name = "richiesta-preventivo-preview";
        link.params.idPreventivo = source.link.idPreventivo;
      }

      return link;
    },
    async segnaNotificheTutteLette() {
      this.bottoneSegnaNotificheVisibiliLette = true;
      await this.$store.dispatch("notifications/markAllRead");
      if (this.isAuth) {
        if (
          this.$route.name &&
          this.$route.name != "form-contatti-empty" &&
          this.$route.name != "form-contatti-lingua" &&
          this.$route.name != "form-contatti-flag" &&
          this.$route.name != "form-contatti-emptyl" &&
          this.$route.name != "form-contatti-lingual" &&
          this.$route.name != "form-contatti-flagl"
        ) {
          var user = JSON.parse(await this.$store.getters["auth/getUser"]);
          if (user.packLevel > 0) {
            this.notifications = await this.$store.dispatch(
              "notifications/getNotifications",
              { index: this.notificationsIndex }
            );
          }
        }
      }
      this.bottoneSegnaNotificheVisibiliLette = false;
    },
    async segnaNotificheVisibiliLette() {
      this.showDeleteDialog = true;
    },
    async segnaNotificheVisibiliLetteOK() {
      this.bottoneSegnaNotificheVisibiliLette = true;
      var notificheVisibili = [];
      this.notifications.notif.forEach((notifica) => {
        notificheVisibili.push(notifica._id);
      });
      for (let i = 0; i < notificheVisibili.length; i++) {
        await this.$store.dispatch(
          "notifications/markRead",
          notificheVisibili[i]
        );
      }
      if (this.isAuth) {
        if (
          this.$route.name &&
          this.$route.name != "form-contatti-empty" &&
          this.$route.name != "form-contatti-lingua" &&
          this.$route.name != "form-contatti-flag" &&
          this.$route.name != "form-contatti-emptyl" &&
          this.$route.name != "form-contatti-lingual" &&
          this.$route.name != "form-contatti-flagl"
        ) {
          var user = JSON.parse(await this.$store.getters["auth/getUser"]);
          if (user.packLevel > 0) {
            this.notifications = await this.$store.dispatch(
              "notifications/getNotifications",
              { index: this.notificationsIndex }
            );
          }
        }
      }
      this.bottoneSegnaNotificheVisibiliLette = false;
      this.showDeleteDialog = false;
    },
    openNotificationPanel() {
      setTimeout(() => {
        if (document.getElementById("overlay_panel")) {
          document.getElementById("overlay_panel").style.position = "fixed";
          document.getElementById("overlay_panel").style.top = "47px";
          document.getElementById("overlay_panel").style.right = "0";
          document.getElementById("overlay_panel").style.left = "auto";
        }
      }, 5);
    },
    async markAsRead(id) {
      await this.$store.dispatch("notifications/markRead", id);
      if (this.isAuth) {
        if (
          this.$route.name &&
          this.$route.name != "form-contatti-empty" &&
          this.$route.name != "form-contatti-lingua" &&
          this.$route.name != "form-contatti-flag" &&
          this.$route.name != "form-contatti-emptyl" &&
          this.$route.name != "form-contatti-lingual" &&
          this.$route.name != "form-contatti-flagl"
        ) {
          var user = JSON.parse(await this.$store.getters["auth/getUser"]);
          if (user.packLevel > 0) {
            this.notifications = await this.$store.dispatch(
              "notifications/getNotifications",
              { index: this.notificationsIndex }
            );
          }
        }
      }
    },

    async getEmailsUnread() {
      // this.n_notifiche = await this.$store.dispatch("mail/newMails");
      // console.log("🚀 ~ file: TheNavbar.vue:946 ~ getEmailsUnread ~ n_notifiche:", this.n_notifiche)
    },
    // Ho separato la logica di update in una funzione dedicata e pulita
    async fetchAndSetNotifications() {
      // Controllo percorsi esclusi (come avevi già scritto tu)
      const excludedRoutes = [
        "form-contatti-empty", "form-contatti-lingua", "form-contatti-flag",
        "form-contatti-emptyl", "form-contatti-lingual", "form-contatti-flagl"
      ];

      if (!this.isAuth || !this.$route.name || excludedRoutes.includes(this.$route.name)) {
        document.title = this.tabTitle;
        return;
      }

      var user = JSON.parse(await this.$store.getters["auth/getUser"]);

      if (user.packLevel > 0) {
        // Chiamata Vuex che fa il fetch al backend (resta invariata)
        this.notifications = await this.$store.dispatch(
          "notifications/getNotifications",
          { index: this.notificationsIndex }
        );

        if (this.notifications.count > 0) {
          document.title = "(❗) (" + this.notifications.count + ") " + this.tabTitle;
        } else {
          document.title = this.tabTitle;
        }
      } else {
        document.title = this.tabTitle;
      }
    },
  },
  onBeforeMount() {
    this.$forceUpdate();
  },
  beforeDestroy() {
    // È buona norma disconnettere il socket quando il componente viene distrutto
    if (this.socket) {
      this.socket.disconnect();
    }
  },
  async mounted() {
    // Inizializza la connessione WebSocket
    // Inserisci l'URL base del tuo backend
    this.tabTitle = document.title;
    const base_address = this.$store.getters["settings/getBaseAddress"];
    this.socket = io(base_address, {
      transports: ['websocket']
    });

    // Gestisci l'autenticazione iniziale e l'unione alla stanza
    if (this.isAuth) {
      const user = JSON.parse(await this.$store.getters["auth/getUser"]);
      if (user && user.camping) {
        // Comunica al server a quale stanza camping apparteniamo
        this.socket.emit('join_camping_room', user.camping);
      }

      // Carica le notifiche al primo avvio
      this.fetchAndSetNotifications();
      this.checkNotifications();
    }

    // Ascolta il ping dal server
    this.socket.on('nuova_notifica', () => {
      // Quando il server ci avvisa, riscarichiamo i dati aggiornati
      this.fetchAndSetNotifications();
    });
    setTimeout(() => {
      this.checkNotifications();
    }, 100);
  },
  computed: {
    homeLink() {
      if (this.auth) {
        if (this.$route.name != "dashboard") {
          return { name: "dashboard" };
        } else {
          return { name: "home" };
        }
      } else {
        return { name: "home" };
      }
    },
    getUser() {
      return this.user.name;
    },
    NomeCapeggio() {
      if(this.camping){
          return this.camping.name;
      } else return "";
      // var tmp_campeggio = this.$store.getters["auth/getCampings"];
      // if (
      //   typeof this.user === "object" &&
      //   this.user !== null &&
      //   "camping" in this.user
      // ) {
      //   var id_campeggio = this.user.camping;

      //   tmp_campeggio = tmp_campeggio.find((e) => e._id == id_campeggio);
      //   if (
      //     typeof tmp_campeggio === "object" &&
      //     tmp_campeggio !== null &&
      //     "name" in tmp_campeggio
      //   )
      //     return tmp_campeggio.name;
      //   else return "";
      // } else {
      //   return "";
      // }
    },
  },
  watch: {
    async $route(new_route) {
      await this.checkAuth();
      if (new_route.name === "richiesta-preventivo-preview")
        if (this.isAuth)
          if (
            this.$route.name &&
            this.$route.name != "form-contatti-empty" &&
            this.$route.name != "form-contatti-lingua" &&
            this.$route.name != "form-contatti-flag" &&
            this.$route.name != "form-contatti-emptyl" &&
            this.$route.name != "form-contatti-lingual" &&
            this.$route.name != "form-contatti-flagl"
          ) {
            var user = JSON.parse(await this.$store.getters["auth/getUser"]);
            if (user.packLevel > 0) {
              this.notifications = await this.$store.dispatch(
                "notifications/getNotifications",
                { index: this.notificationsIndex }
              );
            }
          }
    },
  },
};
</script>

<style
  scoped
  lang="scss"
  src="../../assets/css/components/UI/TheNavbar_scoped.scss"
></style>
<style>
@import "../../assets/css/components/UI/TheNavbar_general.scss";

/* @media (max-width: 1200px) {
  .nav-bar-responsive {
    display: none;
  }
  .nav-custom-bar {
    display: none;
  }
  .submenu {
    display: none;
  }
}
@media (min-width: 1200px) {
  .nav-mobile-bar {
    display: none;
  }
} */
#overlay_panel {
  /* position: fixed !important; */
  /* display: block !important; */
}
</style>
